<template>
  <div class="wrapper">
    <div class="address">
      <div class="item">
        <span class="name">姓名</span>
        <input type="text" class="contact" v-model="contact">
      </div>
      <div class="item">
        <span class="name">电话</span>
        <input type="text" class="tel" v-model="phone">
      </div>
      <div class="item address-item">
        <span class="name">地址</span>
        <textarea rows='3' class="address-value" v-model="address"></textarea>
      </div>
    </div>

    <p class="save-address"><input type="button" class="save-btn" :class="{'btn-disable':checkValid()}" value="保存" @click="saveAddress()"></p>

  </div>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../utils.scss";
  $base-color:#79BD50;
  .wrapper {
    overflow: hidden;
  }
  .address {
    background: white;
    padding-left: px2rem(20px);
    margin-top: px2rem(20px);
    .item {
      display: flex;
      @include font-dpr(16px);
      color: #333;
      height: px2rem(44px);
      line-height: px2rem(44px);
      border-bottom: 1px solid #e5e5e5;
      vertical-align: top;
      input, textarea {
        margin-left: px2rem(16px);
        flex: 1;
        border:0;
      }
      textarea {
        margin-top: px2rem(5px);
      }
    }
    .address-item {
        height: px2rem(92px);
        textarea {
          line-height: px2rem(30px);
          resize: none;
        }
    }

  }

  .save-address {
    display: flex;
    .save-btn {
      flex: 1;
      margin: 0 px2rem(20px);
      height: px2rem(48px);
      border-radius: px2rem(4px);
      background: $base-color;
      border: 0px;
      @include font-dpr(18px);
      margin-top: px2rem(20px);
      color: white;
    }
    .btn-disable {
      color: #999;
      background: #c1c1c1;
    }
  }

</style>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'hello',
  data() {
    return {
      phone: '',
      contatct: '',
      address:'',
    };
  },

  computed: {
    ...mapGetters({
      oldAddress: 'myAddress',
      forCustomer: 'forCustomer',
    }),

  },

  created() {
    this.contact = this.oldAddress.name;
    this.phone = this.oldAddress.tel;
    this.address = this.oldAddress.street;
  },

  methods: {
    saveAddress() {
        let phone = this.phone;
        let contact = this.contact;
        let address = this.address;
        if(!contact){
            alert("请填写联系人！");
            return false;
        }
        if(!address){
            alert("请填写地址！");
            return false;
        }
        if(!(/^1[3-9]\d{9}$/.test(phone))) {
            alert("请填写正确手机号！");
            return false;
        }
        if(!this.oldAddress._id) {
            this.$store.dispatch('saveAddress', { forCustomer: this.forCustomer, address: {phone, contact, address}} );
        } else if (!(phone == this.oldAddress.tel && contact == this.oldAddress.name && this.oldAddress.street == address)) {
            this.$store.dispatch('editAddress', {forCustomer: this.forCustomer, address: {phone, contact, address, _id: this.oldAddress._id}});
        }
       this.$router.go(-1)
    },
    checkValid() {
       return !(!!this.contact && !!this.phone && !!this.address && /^1[3-9]\d{9}$/.test(this.phone));
    }
  }

};
</script>




// WEBPACK FOOTER //
// Address.vue?7843901c